import { useEffect, useRef } from 'react';
import { Message } from './Message';
import styles from './AssistantSidebar.module.scss';

export const MessageList = ({ messages }) => {
	const messagesEndRef = useRef(null);

	// Auto-scroll to bottom when new messages arrive
	useEffect(() => {
		messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
	}, [messages]);

	return (
		<div className={styles.messageList}>
			{messages.map((message) => (
				<Message key={message.id} message={message} />
			))}
			<div ref={messagesEndRef} />
		</div>
	);
};
